import { useEffect, useState, useRef } from "react";

const BASE_WIDTH = 1400; // ganti sesuai lebar asli jadwal

export default function PreviewWrapper({ children, scale: scaleProp }) {
  const [scale, setScale] = useState(1);
  const contentRef = useRef(null);

  useEffect(() => {
    if (scaleProp !== undefined) {
      setScale(scaleProp);
      return;
    }
    function handleResize() {
      if (!contentRef.current) return;
      const contentHeight = contentRef.current.scrollHeight;
      const scaleW = window.innerWidth / BASE_WIDTH;
      const scaleH = window.innerHeight / contentHeight;
      setScale(Math.min(scaleW, scaleH));
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [scaleProp]);

  return (
    <div
      style={{
        width: BASE_WIDTH,
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        margin: "0 auto",
        padding: "10px",
        backgroundImage: "url('/images/background-full.png')",
        backgroundSize: "cover",
        boxShadow: "0 0 16px #0002",
      }}
    >
      <div ref={contentRef}>
        {children}
      </div>
    </div>
  );
} 